/* eslint-disable no-useless-escape */
import { useState } from "react";
import EYEPassword from "../../assets/image/EYEPassword.svg";
import SearchForMachine from "../../assets/image/SearchForMachine.svg";
import LockImage from "../../assets/image/isLock.svg";

const InputField = ({
  defaultValue = "",
  isStar = false,
  isPassword = false,
  isNewError = false,
  isLock = false,
  label,
  name,
  register,
  required = false,
  type = "text",
  errors,
  placeholder,
  disabled,
  isSearchIcon,
}) => {
  const validationRules = required ? { required: `${label} is required` } : {};
  function getValue(obj, path) {
    return path
      .split(/[\.\[\]]+/)
      .filter(Boolean)
      .reduce((acc, key) => acc?.[key], obj);
  }
  const [PasswordShow, setPasswordShow] = useState(false);

  const errorMessage = isNewError ? getValue(errors, name)?.message : null;
  return (
    <div className="form-group" style={{ height: "85px" }}>
      <label htmlFor={name} className="form-label label_class_name_for_input">
        {label}{" "}
        {(required || isStar) && <span style={{ color: "#FF3939" }}>*</span>}
      </label>
      <div className="d-flex">
        {register && name && typeof name === "string" && (
          <input
            id={name}
            type={PasswordShow ? "text" : type}
            {...register(name, validationRules)}
            className="form-control input-common Poppins_400"
            placeholder={placeholder}
            disabled={disabled}
            defaultValue={defaultValue}
            onKeyDown={(e) => {
              if (e?.key === "Enter" && e?.target?.name === "MachineID") {
                e.preventDefault();
              }
            }}
          />
        )}
        {isSearchIcon && (
          <div className="Input_Search">
            <img src={SearchForMachine} alt="Search Machine" />
          </div>
        )}
        {isLock && (
          <div className="Input_Lock">
            <img src={LockImage} alt="Lock" />
          </div>
        )}
        {isPassword && (
          <span
            className="showpassbtn  Input_Lock"
            style={{ cursor: "pointer" }}
            onClick={() => setPasswordShow(!PasswordShow)}
          >
            {PasswordShow ? (
              <>
                <img src={EYEPassword} alt="Password View" />
              </>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-eye-off"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M3 3l18 18"></path>
                <path d="M10.584 10.587a2 2 0 0 0 2.828 2.83"></path>
                <path d="M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341"></path>
              </svg>
            )}
          </span>
        )}
      </div>
      {errors[name] && <p className="input_error">{errors[name].message}</p>}
      {isNewError && <p className="input_error">{errorMessage}</p>}
    </div>
  );
};

export default InputField;
